import {Pipe, PipeTransform} from '@angular/core';
import {toIcdFormat} from '../../utils/string.utils';

@Pipe({name: 'icdCode'})
export class IcdCodePipe implements PipeTransform {
    transform(input: string): string {
        return toIcdFormat(input);
    }
}
